import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import "@bios/ui/styles.css";
import "./app.css";
import { App } from "./App.js";
import { InstallPrompt } from "./components/InstallPrompt.js";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

const root = ReactDOM.createRoot(document.getElementById("root")!);

if (!PUBLISHABLE_KEY && import.meta.env.DEV) {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App devModeNoAuth />
        <InstallPrompt />
      </BrowserRouter>
    </React.StrictMode>,
  );
} else if (!PUBLISHABLE_KEY) {
  root.render(
    <React.StrictMode>
      <div
        style={{
          display: "grid",
          minHeight: "100vh",
          placeItems: "center",
          padding: 24,
          color: "var(--bios-text-muted)",
          fontFamily: "var(--bios-sans)",
          textAlign: "center",
        }}
      >
        Clerk is not configured for this deployment.
      </div>
    </React.StrictMode>,
  );
} else {
  root.render(
    <React.StrictMode>
      <ClerkProvider
        publishableKey={PUBLISHABLE_KEY}
        signInUrl="/sign-in"
        signUpUrl="/sign-up"
        signInFallbackRedirectUrl="/app"
        signUpFallbackRedirectUrl="/app"
        appearance={{
          variables: {
            colorPrimary: "#d4a017",
            colorBackground: "#0d1117",
            colorText: "#e6edf3",
            colorInputBackground: "#07090c",
            colorInputText: "#e6edf3",
          },
        }}
      >
        <BrowserRouter>
          <App />
          <InstallPrompt />
        </BrowserRouter>
      </ClerkProvider>
    </React.StrictMode>,
  );
}
